import { render, staticRenderFns } from "./createServicos.vue?vue&type=template&id=e837dc8e&scoped=true&"
import script from "./createServicos.vue?vue&type=script&lang=js&"
export * from "./createServicos.vue?vue&type=script&lang=js&"
import style0 from "./createServicos.vue?vue&type=style&index=0&id=e837dc8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e837dc8e",
  null
  
)

export default component.exports